import { EnvironmentNames } from "@origin-digital/platform-enums";
import { IAuth0Config } from "../interfaces";
import { auth0ConfigStaging } from "./staging";

/**
 * Brand values tal-core writes to `window.oetal.pageData.brand`
 * (`Brand` in @origin-digital/platform-enums >= 1.5).
 */
export const ORIGIN_BRAND = "ORIGIN";
export const FIRST_ENERGY_BRAND = "1ST_ENERGY";

/**
 * Auth0 clients for brands other than Origin. Origin keeps using auth0EnvConfigs.
 * Each brand logs in through authcallback's /auth/callback, which runs the brand's PKCE
 * login from the page brand and stores the session with refresh tokens; TAL reads and
 * renews that session with this config.
 */
export const auth0BrandConfigs: Record<
  string,
  Partial<Record<EnvironmentNames, IAuth0Config>>
> = {
  [FIRST_ENERGY_BRAND]: {
    // Staging only until the 1st Energy client exists in other environments.
    staging: {
      ...auth0ConfigStaging,
      clientId: "6Kz7P7H9JFAOtIMPWmxql9gNvYJGLLkM",
      // Same scope as the authcallback PKCE login, so both SDKs use the same cache key.
      scope: "openid profile email all",
      useRefreshTokens: true,
    },
  },
};

/** The current page's brand, or undefined when tal-core did not set one. */
export const getBrand = (): string | undefined =>
  typeof window === "undefined" ? undefined : window.oetal?.pageData?.brand;
